<div class="app-slideshow">
    <app-slideshow />
</div>
<div class="home-container">
    <div class="home">
        <div class="title-container">
            <div class="title">
                <h1>Ismerje meg a Regenero Egészségház szolgáltatásait!</h1>
                <p>
                    A Regenero Egészségház évtizedes múltra visszatekintő szakrendelő Budapest XIII. kerületében, melynek profiljába a
                    szakterületek széles köre tartozik, laborvizsgálatokkal egyaránt!
                </p>
            </div>
        </div>
        <div class="button">
            <div routerLink="/consultatinghours" class="consultation-time">
                <b [ngStyle]="{ padding: '8px', 'font-style': 'normal' }">TEKINTSE MEG SZAKRENDELÉSEINK IDŐPONTJAIT</b>
            </div>
            <div class="online-reserve">
                <a
                    href="{{ bookAppointmentsUrl }}"
                    target="_blank"
                    [ngStyle]="{ 'text-decoration': 'none', color: '#413C3F' }"
                    (click)="settingUpLinkToGoogleAnalytics()"
                    ><b [ngStyle]="{ padding: '8px', 'font-style': 'normal' }">ONLINE IDŐPONT FOGLALÁS SZAKRENDELÉSRE</b></a
                >
            </div>
        </div>
        <div class="consultation-container">
            <pf-consultation />
        </div>
        <div class="health-fund-container">
            <div class="health-fund">
                <h2>Akár egészségkártyával is!</h2>
                <div class="health-funds-text">
                    <span>
                        Önnek is van egészségpénztára? A Regenero számos egészségpénztári partnerrel áll már szerződésben, nagy eséllyel az
                        önével is! </span
                    ><br />
                    <span>
                        Nézze meg folyamatosan bővülő partnereink listáját, hogy az Ön számára fontos vizsgálatokat egészségkártyájával is
                        tudja fizetni! </span
                    ><br />
                    <span>
                        Nem találja partnereink között az Ön egészségpénztárát? Ne csüggedjen, csak egy telefonjába kerül, hogy rendszeresen
                        bővülő listánk egy Ön által kívánt egészségpénztárral gyarapodjon!
                    </span>
                </div>
                <br />
                <div class="health-button">
                    <button routerLink="/healthfund">EGÉSZSÉGPÉNZTÁRI PARTNEREINK</button>
                </div>
            </div>
        </div>
        <div class="regenero-container">
            <div class="regenero">
                <h2>Mi vagyunk a Regenero Egészségház</h2>
                <span>
                    A Regenero Egészségház már több, mint egy évtizedes múltra tekinthet vissza. 2011-ben jött létre, dr. Reismann Péter
                    belgyógyász, endokrinológus szakorvos vezetésével. Az akkor még szerény méretű, két rendelővel rendelkező intézmény
                    célja az volt, hogy a szakterületek széles körében nyújtson járóbeteg szakellátást. Az akkor beindított szakrendelések –
                    ortopédia, kardiológia, endokrinológia, bőrgyógyászat, gasztroenterológia, laborvizsgálatok, reumatológia – azóta is
                    markánsan meghatározzák a rendelő profilját.
                </span>
                <span>
                    2021-ben – a koronavírus-járvány lecsengése után, amely sok nehézséget okozott a Regenero Egészségháznak is – már
                    látható volt, hogy a megnövekedett igények kiszolgálása csak nagyobb rendelővel képzelhető el. Az új helyszín
                    kiválasztásánál kiemelten fontos volt, hogy a XIII. kerület maradjon meg, hiszen ekkor már a kerület orvosi ellátásának
                    ismert szereplője volt az intézmény. 2023-ban létrejött a megállapodás a Generali Biztosító és a Regenero Egészségház
                    között, melynek folyományaképp a rendelő a Generali Váci úti irodaházába költözött.
                </span>
                <span>
                    Az új rendelő építése egyben korszerűsítést is hozott. A kétszer akkora helyre történő költözés során megújult a
                    diagnosztikai eszközpark, s az Egészségház újabb szakrendelésekkel is bővült.Az informatikai fejlesztések a páciensek
                    kényelmét és adatainak biztonságát garantálják, míg a meghosszabbított nyitvatartási idő és a szakorvosok megnövekedett
                    száma a gyorsabb ellátáshoz jutást segítik.
                </span>
                <span>
                    Van persze, ami változatlan: a Regenero Egészségházban továbbra is tapasztalt,a szakterületükön kiemelkedő tudással
                    rendelkező, empatikus, segítőkész szakorvosok várják pácienseiket. Hiszünk abban, hogy a legjobb reklám az elégedett
                    páciens. </span
                ><br />
                <a href="{{ bookAppointmentsUrl }}" target="_blank" (click)="settingUpLinkToGoogleAnalytics()"
                    >FOGLALJON HOZZÁNK IDŐPONTOT!</a
                >
            </div>
        </div>

        <!-- <div *ngFor="let homeConfig of homeConfigList" class="newbooks-home">
            <div *ngIf="homeConfig.active">
                <pf-freshnews *ngIf="homeConfig.component === 'pf-freshnews'"></pf-freshnews>
            </div>
        </div> -->
        <div class="blogs">
            <app-blogs />
        </div>
        <div class="map">
            <div class="map-container">
                <div class="google-map">
                    <iframe width="500" height="320" frameborder="0" [src]="googleMapIframeSrc"></iframe>
                </div>
                <div class="google-map-mobile">
                    <iframe width="100%" height="100%" frameborder="0" [src]="googleMapIframeSrc"></iframe>
                </div>
                <div class="address">
                    <div>Látogasson el hozzánk!</div>
                    <div>Ha minőségi orvosi ellátásra vágyik, lépjen velünk kapcsolatba, foglaljon hozzánk időpontot konzultációra!</div>
                    <div>
                        Felújított, korszerű egészségügyi rendelőnk a 13. kerületben található Budapesten, mindössze pár percre a Lehel
                        tértől!
                    </div>
                    <div>Címünk: 1132 Budapest, Csanády utca 1-3.</div>
                    <div>Könnyedén megközelíthetők vagyunk tömegközlekedéssel:</div>
                    <div>
                        <ul>
                            <li>M3-as metró (Lehel tér)</li>
                            <li>14-es villamos (Lehel tér)</li>
                            <li>15-ös busz (Csanády utca)</li>
                            <li>76-os troli (Csanády utca)</li>
                        </ul>
                    </div>
                    <div>Szeretettel várjuk rendelőnkben!</div>
                    <div class="map-ref">
                        <a href="{{ bookAppointmentsUrl }}" target="_blank" (click)="settingUpLinkToGoogleAnalytics()"
                            >IDŐPONTOT FOGLALOK!</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="consulting-hour-container">
        <div class="consulting-top">
            <div class="consulting-top-content">
                <div class="top">
                    <a href="https://medicall.cc/idopontfoglalas/regenero/index" target="_blank">
                        <button type="button">
                            <mat-icon>calendar_today</mat-icon>
                            <span class="ml-2 mr-2">|</span><b>{{ 'Online időpontfoglalás' | uppercase }}</b>
                        </button>
                    </a>
                </div>
                <div class="top">
                    <a routerLink="/consultatinghours">
                        <button type="button">
                            <mat-icon>calendar_view_day</mat-icon>
                            <span class="ml-2 mr-2">|</span><b>{{ 'Szakrendelések időpontjai' | uppercase }}</b>
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>-->
</div>
